// ProfileContext.js
import React from 'react';

const ProfileContext = React.createContext({
  profile: { currentCompany: '', totalExperience: 0 },
  setProfile: () => {},
});

export default ProfileContext;
